import * as React from 'react';
import { SortState } from '@rtkwlf/ui';

export function useSortTableName<T extends { name: string }>() {
  const [sortState, setSortState] = React.useState<SortState>('none');
  const sort = React.useCallback(
    (data: T[]) => {
      switch (sortState) {
        case 'dsc':
          return [...data].sort((b, a) => a.name.localeCompare(b.name));
        case 'asc':
          return [...data].sort((a, b) => a.name.localeCompare(b.name));
        default:
          return data;
      }
    },
    [sortState],
  );

  const handleSort = React.useCallback(
    (column: string, state: SortState) => {
      setSortState(state);
    },
    [setSortState],
  );

  return { handleSort, sort };
}
